/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { constant } from 'lodash';

export type WithLegend<T> = T & {
  legendLayout?: Maybe<ChartLegendCell>[][];
  axisLayout?: Maybe<string>[];
};
export type ChartSpecsWithLegend = WithLegend<google.visualization.ChartSpecs>;

export enum ChartLegendCellType {
  Line = 'line',
  LineWithDots = 'lineWithDots',
  Bar = 'bar',
  DashedLine = 'dashedLine',
}

export interface ChartLegendCell {
  style: ChartLegendCellType;
  color: string;
  label: string;
}

export const chartLegendRow = (...cells: Maybe<ChartLegendCell>[]) => cells;
export const chartLegendCellBar = (label: string, color: string): ChartLegendCell =>
  ({ style: ChartLegendCellType.Bar, label, color });
export const chartLegendCellLine = (label: string, color: string): ChartLegendCell =>
  ({ style: ChartLegendCellType.Line, label, color });
export const chartLegendCellLineWithDots = (label: string, color: string): ChartLegendCell =>
  ({ style: ChartLegendCellType.LineWithDots, label, color });
export const chartLegendCellDashedLine = (label: string, color: string): ChartLegendCell =>
  ({ style: ChartLegendCellType.DashedLine, label, color });
export const chartLegendCellNone = constant(void 0);

export const mapLegend = (rows: Maybe<ChartLegendCell>[][],
                          transform: IdentityFn<Maybe<ChartLegendCell>>) => rows.map((row) => row.map(transform));
